import Footer from "../Components/Footer";
import Header from "../Components/Header";
import "./HomePage.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dashboard from "../assets/Dashboard-front.png"
import leave from "../assets/Leave.png"
import attendance from "../assets/Attendance.png"
import announcement from "../assets/Announcement.png"
import cloud from "../assets/Cloud.png"
import experiance from "../assets/employee-experiance.png"
import hr from "../assets/one-stop-hr.png"
import payroll from "../assets/Payroll.png"
import apprisal from "../assets/Appraisal.png"
import payslip from "../assets/pay-slips.png"
import RegisterForm from "./RegisterForm/RegisterForm";
import SubscripationPlanVeiwController from "../redux/actions/SubscripationPlanAction";
import DemoRequestForm from "./DemoRequest/AddDemoRequest";
import { Link, useNavigate } from "react-router-dom";


  
  


const Home = () => {
  
  const navigate = useNavigate();

  const handleGetStartedClick = () => {
    // you can add any logic here (e.g., analytics, tracking)
    navigate("/contact-us");
  }
  const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // modal state
     const [showDemoForm, setShowDemoForm] = useState(false);
     const { getPlans} = SubscripationPlanVeiwController();
  const { plans } = useSelector((state) => state.subscripation);

  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  //    const handleGetStartedClick = (e) => {
  //   e.preventDefault(); // prevent default anchor behavior
  //   setShowModal(true); // open modal
  // };

  const closeModal = () => {
    setShowModal(false); // close modal
  };
const handleDemoClick = (e) => {
    e.preventDefault();
    setShowDemoForm(true);
  };
  const closeDemoForm = () => setShowDemoForm(false);


  return (
    <>
       <section className="hero hero-gradient" >
        <div className="hero-content">
          <h1>
            Engage. Perform. <br />
            Develop. <br />
            Comply — <span >and Thryiv</span>
          </h1>
          <p className="subtitle">
            The complete SaaS platform for HRMS, Payroll & Compliance — built
            for modern organizations and employee-first teams.
          </p>

          <div className="cta-buttons">
            {/* <a href="#get-started" className="btn btn-primary" onClick={handleGetStartedClick}>
              Get Started
            </a> */}
             <button type="button" className="btn btn-primary" onClick={handleDemoClick}>
  Get Started
</button>

          </div>

          {/* <div className="badges">
            <span className="badge green">● Secure & Compliant</span>
            <span className="badge orange">● Cloud-ready</span>
          </div> */}
        </div>

        <div className="hero-image">
             <div className="outer-box">
  <div className="main-grid">
    {/* Left column */}
    <div className="left-col">
      <div className="bar-sm"></div>
      <div className="box"></div>
      <div className="box"></div>
      <div className="box"></div>
    </div>

    {/* Right column */}
    <div className="right-col">
      <div className="top-row">
        <div className="bar-lg"></div>
        <div className="bar-md"></div>
      </div>
      <div className="color-grid">
        <div className="color-card green"></div>
        <div className="color-card orange"></div>
        <div className="color-card blue"></div>
      </div>
      <div className="big-box"></div>
    </div>
  </div>
  </div>
</div>
      </section>

<section id="features" className="features-section">
  <h2 className="features-title">Everything HR, in One Platform</h2>
  <p className="features-subtitle">
    Simple for employees. Powerful for HR managers. Bring engagement,
    performance, development and compliance into a single workflow.
  </p>
  
  <div className="feature-card">
    <div className="features-grid engage">
      <div className="image-container">
        <img src={attendance} alt="Attendance" className="attendance-img" />
      </div>
      <div className="features-info">
        <h3>Engage</h3>
        <ul>
          <li>
            <strong>Employee Self-Service</strong>
            <p>
              Empower employees with self-service to update details, view payslips, and manage requests.
            </p>
          </li>
          <li>
            <strong>Attendance & Leave</strong>
            <p>Track clock-ins, hours, and leave requests with real-time accuracy.</p>
          </li>
          <li>
            <strong>Announcements & Tasks</strong>
            <p>Share updates, assign tasks, and monitor progress from one dashboard.</p>
          </li>
        </ul>
      </div>
    </div>
  
    <div className="features-grid perform">
      <div className="features-info">
        <h3>Perform</h3>
        <ul>
          <li>
            <strong>Appraisals & reviews</strong>
            <p>Run fair, transparent performance reviews with easy tracking and feedback.</p>
          </li>
          <li>
            <strong>Goals & OKRs</strong>
            <p>Set clear objectives and measurable key results for every team. Monitor progress in real time.</p>
          </li>
          <li>
            <strong>Productivity insights</strong>
            <p>Get actionable analytics on team performance and work patterns.</p>
          </li>
        </ul>
      </div>
      <div className="image-container">
        <img src={apprisal} alt="Apprisal" className="apprisal-img" />
      </div>
    </div>
    <div className="features-grid engage">
      <div className="image-container">
        <img src={payslip} alt="Payslip" className="payslip-img" />
      </div>
      <div className="features-info">
        <h3>Comply</h3>
        <ul>
          <li>
            <strong>Payroll & payslips</strong>
            <p>Automate salary calculations with accurate deductions and bonuses.</p>
          </li>
          <li>
            <strong>PF/ESIC/Tax reports</strong>
            <p>Stay compliant with statutory PF, ESIC, and tax regulations.</p>
          </li>
          <li>
            <strong>Policy & contracts</strong>
            <p>Store and manage company policies and employee contracts in one place.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section id="screens" className="screens-section">
  <div className="screens-container">
    <div className="screens-grid">
      
      <div className="screens-text">
        <h2>Simple for employees. Powerful for HR managers.</h2>
        <p>
          Clean dashboards for employees, with deep controls for admins.
          Attendance, leave, payroll, and compliance handled in one flow.
        </p>
        {/* <div className="screens-buttons">
          <a href="#cta" className="btn btn-primary" onClick={handleGetStartedClick}>Start Free Trial</a>
          <a href="#contact" className="btn btn-outline">Request Demo</a>
        </div> */}
      </div>
      <div className="screens-image">
      <div className="image-wrapper">
        <img src={dashboard} alt="Dashboard placeholder" />
      </div>
    </div>
    </div>
  </div>
</section>

<section className="why-thryiv-section">
  <div className="why-thryiv-container">
   
    <h2 className="why-thryiv-title h2">Why Thryiv</h2>
    <p className="why-thryiv-subtitle">
      One-stop HR platform that empowers employees and HR managers alike.
    </p>

   
    <div className="why-thryiv-features">
     
      <div className="why-thryiv-card hr">
      {/* Image */}
      <div className="why-thryiv-card-image">
        <img src={hr} alt="HR Operations" />
      </div>

      {/* Title below image */}
      <h3 className="why-thryiv-card-title">One‑stop HR operations</h3>
    </div>

     
      <div className="why-thryiv-card payroll">
        <div className="why-thryiv-card-image">
        <img src={payroll} alt="payroll" />
      </div>

      {/* Title below image */}
      <h3 className="why-thryiv-card-title">Seamless payroll & compliance</h3>
      </div>

    
      <div className="why-thryiv-card experience">
        <div className="why-thryiv-card-image">
        <img src={experiance} alt="Experience" />
      </div>

      {/* Title below image */}
      <h3 className="why-thryiv-card-title">Employee‑first experience</h3>
      </div>

     
      <div className="why-thryiv-card cloud">
        <div className="why-thryiv-card-image">
        <img src={cloud} alt="Cloud Ready" />
      </div>

      {/* Title below image */}
      <h3 className="why-thryiv-card-title">Secure, scalable, and cloud‑ready</h3>
      </div>
    </div>
  </div>
</section>

 {/* <section id="pricing" className="pricing-section">
        <div className="pricing-container">
          <h2 className="h2">Simple Pricing</h2>
          <p className="subtitle">
            Transparent per-employee pricing. No hidden fees. Cancel anytime.
          </p>

          <div className="pricing-grid">
           
            {plans &&
              plans.slice(0, 2).map((plan) => (
                <div key={plan.id} className={`pricing-card growth`}>
                  <h3>{plan.name}</h3>
                  <p className="price">
                    ₹{plan.price_per_employee} <span>/employee</span>
                  </p>
                  <ul>
                    {plan.features.split(",").map((feature, idx) => (
                      <li key={idx}>{feature.trim()}</li>
                    ))}
                  </ul>
                  <a
                    href="#"
                    className={`choose-${plan.name.toLowerCase()}-btn`}
                  >
                    {plan.name === "Starter" ? "Choose Starter" : "Choose Growth"}
                  </a>
                </div>
              ))}

            
            <div className="pricing-card startar">
              <h3>Enterprise</h3>
              <p className="price">Custom</p>
              <ul>
                <li>Advanced compliance</li>
                <li>SLA & SSO</li>
                <li>Dedicated success</li>
              </ul>
              <a href="" className="talk-to-sales-btn">
                Talk to Sales
              </a>
            </div>
          </div>
        </div>
      </section> */}

<section id="cta" className="cta-section">
  <div className="cta-container">
    <h2 className="cta-title">Ready to Engage, Perform, Develop, and Comply?</h2>
    <p className="cta-subtitle">
      Get started with Thryiv today. Set up in minutes. Scale with confidence.
    </p>

    <div className="ctbuttons">
  <Link to="/contact-us" className="start-button" onClick={handleGetStartedClick}>
      Start Free Trial
    </Link>
  {/* <a href="#contact" className="btn-outline">Request a Demo</a> */}
</div>
  </div>
</section>

{showModal && <RegisterForm onClose={closeModal} />} 
{showDemoForm && (
        <DemoRequestForm onClose={() => setShowDemoForm(false)} />
      )}
    </>
    
  );
};


export default Home;